import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, Input, VStack, HStack, Box, Text, Button } from "@chakra-ui/react";
import { searchColleagues } from "../../services/messagingService";
import SchemaBadge from "./SchemaBadge";

// Scoped to the assigner's schema group, like the DM picker — assigning work
// shouldn't surface users from other clinics.
export default function ColleaguePicker({ label, onPick, picked, schema }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      return;
    }
    const handle = setTimeout(async () => {
      try {
        const { users } = await searchColleagues(query, schema);
        setResults(users || []);
      } catch {
        setResults([]);
      }
    }, 250);
    return () => clearTimeout(handle);
  }, [query, schema]);

  return (
    <FormControl mb={3}>
      <FormLabel>{label}</FormLabel>
      {picked ? (
        <Box p={2} borderWidth="1px" borderRadius="md">
          <Text fontSize="sm">
            {picked.name || picked.email}
            {picked.name && picked.email && (
              <Text as="span" color="gray.500">
                {" "}
                ({picked.email})
              </Text>
            )}{" "}
            <SchemaBadge schema={picked.current_schema} verticalAlign="middle" />
            <Button size="xs" variant="link" onClick={() => onPick(null)} ml={2}>
              change
            </Button>
          </Text>
        </Box>
      ) : (
        <>
          <Input placeholder="Search by name..." value={query} onChange={(e) => setQuery(e.target.value)} />
          {results.length > 0 && (
            <VStack align="stretch" mt={1} borderWidth="1px" borderRadius="md" maxH="160px" overflowY="auto">
              {results.map((u) => (
                <Box
                  key={u.id}
                  p={2}
                  cursor="pointer"
                  _hover={{ bg: "gray.50" }}
                  onClick={() => {
                    onPick(u);
                    setQuery("");
                    setResults([]);
                  }}
                >
                  <HStack spacing={2}>
                    <Text fontSize="sm" minW={0} overflowWrap="anywhere">
                      {u.name || u.email}
                    </Text>
                    <SchemaBadge schema={u.current_schema} />
                  </HStack>
                  {u.name && u.email && (
                    <Text fontSize="xs" color="gray.500">
                      {u.email}
                    </Text>
                  )}
                </Box>
              ))}
            </VStack>
          )}
        </>
      )}
    </FormControl>
  );
}
